<section>
  <div class="loadspinner" *ngIf="loader">Cargando…</div>

  <div class="container" *ngIf="!loader">
    <div class="card">
      <div class="header-section">
          <div class="col-md-3 text-left">
              <img src="https://firebasestorage.googleapis.com/v0/b/miasistema.appspot.com/o/miaLogoOfficial.png?alt=media&token=e45eede6-4721-4570-b242-bfabbeda7262"
                  width="140">
          </div>
          <div class="col-md-9 text-right header-buttons">
              <!-- <button nbButton status="info" (click)="generateWord()"><mat-icon>insert_drive_file</mat-icon> Exportar como Word</button> -->
              <button mat-button class="danger" printSectionId="printsection" ngxPrint
                  [useExistingCss]="true"><mat-icon>picture_as_pdf</mat-icon> Imprimir en PDF</button>
              <button mat-button class="success" (click)="excel()"><mat-icon> insert_drive_file</mat-icon>
                  Exportar en Excel</button>
          </div>
        </div>     

      <div class="row justify-content-center">
        <h2>Reporte de Excedentes del {{data_source?.startDate | date}} al {{data_source?.endDate | date}}</h2>
      </div>

      <div class="table-container">
        <table mat-table [dataSource]="data_source?.reportData">

          <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef> Cliente </th>
            <td mat-cell *matCellDef="let row"> {{row.client}} </td>
          </ng-container>

          <ng-container matColumnDef="plan">
            <th mat-header-cell *matHeaderCellDef> Plan </th>
            <td mat-cell *matCellDef="let row"> {{row.plan}} </td>
          </ng-container>

          <ng-container matColumnDef="plan_minutes">
            <th mat-header-cell *matHeaderCellDef> Minutos Contratados </th>
            <td mat-cell *matCellDef="let row"> {{row.plan_minutes}} </td>
          </ng-container>

          <ng-container matColumnDef="plan_hours">
            <th mat-header-cell *matHeaderCellDef> Horas Contratadas </th>
            <td mat-cell *matCellDef="let row"> {{row.plan_hours}} </td>
          </ng-container>

          <ng-container matColumnDef="plan_price">
            <th mat-header-cell *matHeaderCellDef> Precio Plan </th>
            <td mat-cell *matCellDef="let row">{{row.plan_price | currency:'MXN'}}</td>
          </ng-container>

          <ng-container matColumnDef="minutesUsed">
            <th mat-header-cell *matHeaderCellDef> Minutos Llamadas </th>
            <td mat-cell *matCellDef="let row"> {{row.minutesUsed}} </td>
          </ng-container>

          <ng-container matColumnDef="hoursUsed">
            <th mat-header-cell *matHeaderCellDef> Horas Laboradas </th>
            <td mat-cell *matCellDef="let row"> {{row.hoursUsed | number:'1.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="excessMinutes">
            <th mat-header-cell *matHeaderCellDef> Excedente Minutos </th>
            <td mat-cell *matCellDef="let row"> {{row.excessMinutes}} </td>
          </ng-container>

          <ng-container matColumnDef="excessHours">
            <th mat-header-cell *matHeaderCellDef> Excedente Horas </th>
            <td mat-cell *matCellDef="let row"> {{row.excessHours | number:'1.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="totalExcess">
            <th mat-header-cell *matHeaderCellDef> Total Excedentes </th>
            <td mat-cell *matCellDef="let row"> {{row.totalExcess}} </td>
          </ng-container>

          <ng-container matColumnDef="excessAmount">
            <th mat-header-cell *matHeaderCellDef> Monto Excedente </th>
            <td mat-cell *matCellDef="let row"> {{row.excessAmount | currency:'MXN'}} </td>
          </ng-container>

          <ng-container matColumnDef="totalToPay">
            <th mat-header-cell *matHeaderCellDef> Total a Pagar </th>
            <td mat-cell *matCellDef="let row"> {{row.totalToPay | currency:'MXN'}} </td>
          </ng-container>

          <ng-container matColumnDef="recommendedUpgrade">
            <th mat-header-cell *matHeaderCellDef> Recomendación </th>
            <td mat-cell *matCellDef="let row"> {{row.recommendedUpgrade}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['client','plan','plan_minutes','plan_hours', 'plan_price' ,'minutesUsed','hoursUsed','excessMinutes','excessHours','totalExcess','excessAmount','totalToPay','recommendedUpgrade']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['client','plan','plan_minutes','plan_hours', 'plan_price','minutesUsed','hoursUsed','excessMinutes','excessHours','totalExcess','excessAmount','totalToPay','recommendedUpgrade'];"></tr>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- Sección oculta solo para imprimir en PDF -->
<div class="row" id="printsection" hidden>
  <div class="col-md-12 col-center">
    <nb-card>
      <nb-card-header style="border-bottom: 2px solid #e26b0a;">
        <div class="row">
          <div class="col-md-5 text-left">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/miasistema.appspot.com/o/miaLogoOfficial.png?alt=media&token=e45eede6-4721-4570-b242-bfabbeda7262"
              width="140"
            />
          </div>
          <div class="col-md-7 text-right">
            <ul style="list-style: none; padding-left: 1px;">
              <li style="color: #e26b0a;">www.miasistente.net</li>
              <li>ventas&#64;miassitente.net</li>
              <li>800 288 02 68</li>
              <li>Cancún Quintana Roo México / Oficinas Centrales</li>
            </ul>
          </div>
        </div>
      </nb-card-header>

      <nb-card-body style="margin-top: 1rem;" *ngIf="data_source">
        <div class="row justify-content-center">
          <div class="col-md-8 text-center">
            <h2>
              Reporte de Excedentes del
              {{ data_source?.startDate | date }} al
              {{ data_source?.endDate | date }}
            </h2>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-md-11 nodata-card">
            <table class="content-table-pdf">
              <thead>
                <tr>
                  <td>Cliente</td>
                  <td>Plan</td>
                  <td>Minutos del Plan</td>
                  <td>Horas del Plan</td>
                  <td>Minutos usados</td>
                  <td>Horas usadas</td>
                  <td>Excedente Minutos</td>
                  <td>Excedente Horas</td>
                  <td>Total Excedentes</td>
                  <td>Monto Excedente</td>
                  <td>Total a Pagar</td>
                  <td>Recomendación</td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of data_source.reportData">
                  <td>{{ item.client }}</td>
                  <td>{{ item.plan }}</td>
                  <td>{{ item.plan_minutes }}</td>
                  <td>{{ item.plan_hours }}</td>
                  <td>{{ item.minutesUsed }}</td>
                  <td>{{ item.hoursUsed | number: '1.2-2' }}</td>
                  <td>{{ item.excessMinutes }}</td>
                  <td>{{ item.excessHours | number: '1.2-2' }}</td>
                  <td>{{ item.totalExcess }}</td>
                  <td>{{ item.excessAmount | currency: 'MXN' }}</td>
                  <td>{{ item.totalToPay | currency: 'MXN' }}</td>
                  <td>{{ item.recommendedUpgrade }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
